// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__jVn-+","title":"NoData_title__74KxK","text":"NoData_text__A8X63"};